import api from "../../services/axiosInstance";
import React, { useState, useEffect } from "react";
import {
  FaRegHeart,
  FaHeart,
  FaRegBookmark,
  FaBookmark,
  FaUser,
  FaUserPlus,
  FaInfoCircle,
  FaSearch,
  FaStar,
  FaCube,
  FaDraftingCompass,
  FaSun,
  FaUserGraduate,
} from "react-icons/fa";

 import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import CourseCard from "../../components/course/CourseCard";
const Courses = () => {
  const [subscribedCourses, setSubscribedCourses] = useState({});
  const [activeFilter, setActiveFilter] = useState('all'); // 'all', 'liked', 'saved', 'subscribed'
  const [likedCourses, setLikedCourses] = useState({});
  const [savedCourses, setSavedCourses] = useState({});
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const getLevelConfig = (niveau) => {
  switch (niveau?.toLowerCase()) {
    case "avancé":
      return {
        bg: "bg-gradient-to-br from-emerald-50 to-teal-100",
        color: "from-emerald-400 to-teal-500",
        badge: "bg-emerald-100 text-emerald-800",
        icon: FaUserGraduate,
      };
    case "intermediate":
      return {
        bg: "bg-gradient-to-br from-blue-50 to-indigo-100",
        color: "from-blue-400 to-indigo-500",
        badge: "bg-blue-100 text-blue-800",
        icon: FaUserGraduate,
      };
    case "advanced":
      return {
        bg: "bg-gradient-to-br from-purple-50 to-pink-100",
        color: "from-purple-400 to-pink-500",
        badge: "bg-purple-100 text-purple-800",
        icon: faUserGraduate,
      };
    default:
      return {
        bg: "bg-gradient-to-br from-gray-50 to-gray-100",
        color: "from-gray-400 to-gray-600",
        badge: "bg-gray-100 text-gray-800",
        icon: faUserGraduate,
      };
  }
};

  useEffect(() => {
  const fetchData = async () => {
    try {
      const { data } = await api.get("/users/preferences/details");

      // merge liked and saved courses
      const allCourses = [
        ...(data.likedCourses || []),
        ...(data.savedCourses || []),
        ...(data.subscribedCourses || []),
      ];
      // remove duplicates by course ID
      const uniqueCourses = Array.from(
        new Map(allCourses.map((course) => [course.id, course])).values()
      );
      console.log("Fetched courses from preferences:", uniqueCourses[0]); 
      const transformedCourses = uniqueCourses.map((course, index) => ({
  id: course.id,
  index,
  title: course.name || "Sans titre",
  description: course.description || "Description non disponible",
  price: course.price ? `${course.price.toLocaleString()} DA` : "—",
  niveau: course.niveau || "Beginner",
  icon: course.icon,
  instructor: {
    name: course.professor_name
 || "Instructeur",
  },
  isLiked: !!likedCourses[course.id],
  isSaved: !!savedCourses[course.id],
}));


      setCourses(transformedCourses);
      await fetchUserPreferences();
    } catch (error) {
      console.error("Error fetching courses:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchData();
}, []);
const filteredCourses = courses.filter(course => {
  if (activeFilter === 'all') return true;
  if (activeFilter === 'liked') return likedCourses[course.id];
  if (activeFilter === 'saved') return savedCourses[course.id];
  if (activeFilter === 'subscribed') return subscribedCourses[course.id];
  return true;
});


  // Fetch liked and saved courses - CORRECTED VERSION
  const fetchUserPreferences = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        console.log("No token found, skipping preferences fetch");
        return;
      }

      const { data } = await api.get("/users/preferences", {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Process liked courses - handle both array and object formats
      const likedCoursesObj = {};
      if (data.likedCourses) {
        if (Array.isArray(data.likedCourses)) {
          // Array format: [{id: 1, ...}, {id: 2, ...}]
          data.likedCourses.forEach(course => {
            if (course && course.id) {
              likedCoursesObj[course.id] = true;
            }
          });
        } else if (typeof data.likedCourses === 'object') {
          // Object format: {1: true, 2: true}
          Object.keys(data.likedCourses).forEach(courseId => {
            if (data.likedCourses[courseId]) {
              likedCoursesObj[courseId] = true;
            }
          });
        }
      }

      // Process subscribed courses - handle both array and object formats
const subscribedCoursesObj = {};
if (data.subscribedCourses) {
  if (Array.isArray(data.subscribedCourses)) {
    data.subscribedCourses.forEach(course => { if(course?.id) subscribedCoursesObj[course.id] = true; });
  } else if (typeof data.subscribedCourses === 'object') {
    Object.keys(data.subscribedCourses).forEach(courseId => {
      if (data.subscribedCourses[courseId]) subscribedCoursesObj[courseId] = true;
    });
  }
}
setSubscribedCourses(subscribedCoursesObj);

      // Process saved courses - handle both array and object formats
      const savedCoursesObj = {};
      if (data.savedCourses) {
        if (Array.isArray(data.savedCourses)) {
          // Array format: [{id: 1, ...}, {id: 2, ...}]
          data.savedCourses.forEach(course => {
            if (course && course.id) {
              savedCoursesObj[course.id] = true;
            }
          });
        } else if (typeof data.savedCourses === 'object') {
          // Object format: {1: true, 2: true}
          Object.keys(data.savedCourses).forEach(courseId => {
            if (data.savedCourses[courseId]) {
              savedCoursesObj[courseId] = true;
            }
          });
        }
      }
      setLikedCourses(likedCoursesObj);
      setSavedCourses(savedCoursesObj);
    } catch (error) {
      console.error("Error fetching preferences:", error);
    }
  };

  // Helper functions
  const getRandomGradient = () => {
    const gradients = [
      "from-blue-600 to-blue-800",
      "from-red-600 to-red-800",
      "from-green-600 to-teal-600",
      "from-purple-600 to-purple-800",
      "from-orange-600 to-orange-800",
      "from-indigo-600 to-indigo-800",
    ];
    return gradients[Math.floor(Math.random() * gradients.length)];
  };


  const getCourseIcon = (category) => {
    const iconMap = {
      architecture: <FaCube className="text-white text-3xl" />,
      design: <FaDraftingCompass className="text-white text-3xl" />,
      rendering: <FaSun className="text-white text-3xl" />,
      bim: <FaCube className="text-white text-3xl" />,
      cad: <FaDraftingCompass className="text-white text-3xl" />,
      default: <FaCube className="text-white text-3xl" />,
    };
    return iconMap[category?.toLowerCase()] || iconMap.default;
  };

  // Toggle like - IMPROVED VERSION
  const toggleLike = async (courseId) => {
    const newLikedState = !likedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour aimer ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/like",
        { courseId, liked: newLikedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      setLikedCourses((prev) => ({ 
        ...prev, 
        [courseId]: newLikedState 
      }));
      
      console.log(`Course ${courseId} liked: ${newLikedState}`);
    } catch (error) {
      console.error("Error liking course:", error);
      alert("Erreur lors de la mise à jour du like");
    }
  };

  // Toggle save - IMPROVED VERSION
  const toggleSave = async (courseId) => {
    const newSavedState = !savedCourses[courseId];
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Veuillez vous connecter pour sauvegarder ce cours");
      return;
    }

    try {
      await api.post(
        "/courses/save",
        { courseId, saved: newSavedState },
        { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
      );

      setSavedCourses((prev) => ({ 
        ...prev, 
        [courseId]: newSavedState 
      }));
      
      console.log(`Course ${courseId} saved: ${newSavedState}`);
    } catch (error) {
      console.error("Error saving course:", error);
      alert("Erreur lors de la mise à jour de la sauvegarde");
    }
  };

  const registerCourse = async (courseId) => {
    const token = localStorage.getItem("accessToken");
    if (!token) {
      alert("Connectez-vous d'abord !");
      return;
    }

    try {
      await api.post(
        "/courses/register",
        { courseId },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      alert(`Inscription au cours ${courseId} réussie !`);
    } catch {
      alert("Erreur lors de l'inscription");
    }
  };

  const showCourseDetails = (courseId) => (window.location.href = `/courses/${courseId}`);
  const showCategoryBrowser = () => (window.location.href = "/all-courses");

  if (loading)
    return (
      <section className="py-20 bg-gray-50 text-center">
        <div className="animate-pulse text-gray-500">Chargement des formations...</div>
      </section>
    );

  return (
    <section id="formations" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">Nos Formations</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Formations professionnelles organisées par domaines d'expertise
          </p>
        </div>
<div className="flex justify-center mb-8 gap-4 flex-wrap">
  <button
    className={`px-4 py-2 rounded-full transition-colors ${
      activeFilter === 'all' 
        ? 'bg-blue-600 text-white' 
        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
    }`}
    onClick={() => setActiveFilter('all')}
  >
    Toutes
  </button>
  <button
    className={`px-4 py-2 rounded-full transition-colors ${
      activeFilter === 'liked' 
        ? 'bg-red-600 text-white' 
        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
    }`}
    onClick={() => setActiveFilter('liked')}
  >
    Likés
  </button>
  <button
    className={`px-4 py-2 rounded-full transition-colors ${
      activeFilter === 'saved' 
        ? 'bg-green-600 text-white' 
        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
    }`}
    onClick={() => setActiveFilter('saved')}
  >
    Sauvegardés
  </button>
  <button
    className={`px-4 py-2 rounded-full transition-colors ${
      activeFilter === 'subscribed' 
        ? 'bg-yellow-600 text-white' 
        : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
    }`}
    onClick={() => setActiveFilter('subscribed')}
  >
    inscrite
  </button>
</div>
        {filteredCourses.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500 text-lg">Aucune formation trouvée.</p>
          </div>
        ) : (
          <>
            <div className="grid md:grid-cols-3 gap-8">
  {filteredCourses.map((course) => (
    <CourseCard 
  key={course.id}
  course={course}
  level={getLevelConfig(course.niveau)}
  isLiked={!!likedCourses[course.id]}
  isSaved={!!savedCourses[course.id]}
  onLike={toggleLike}
  onSave={toggleSave}
  onRegister={(title, id) => registerCourse(id)}
/>

  ))}
</div>


            <motion.div
  className="mt-20 text-center"
>
  <motion.a
    href="#"
    onClick={() => navigate("/all-courses")}
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    className="inline-flex items-center gap-3 text-[#2fb383] font-bold text-lg hover:text-[#269c6f] transition-colors cursor-pointer"
  >
    Plus de formations
    <FontAwesomeIcon icon={faArrowRight} className="text-sm" />
  </motion.a>
</motion.div>
          </>
        )}

      </div>
    </section>
  );
};

export default Courses;